import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

interface ProtectedRouteProps {
  element: JSX.Element
}

export const ProtectedRoute = ({ element }: ProtectedRouteProps) => {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return null // or a loading spinner component if you have one
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return element
}
